var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import i18next from '../../../strings/i18n/i18n';
import { Title } from './subcomponents';
export var getHeaderTitle = function (title, inputValue) {
    var headerTitle = [title];
    var dollarPattern = /(?:%s)/;
    var datePattern = /(?:%d)/;
    /*
     *Splitting the title by %s into an array and replacing values as follows:
     *  Balance exceeds $ %s
     *To
     *  Balance exceeds $ 100 (if inputValue is not empty)
     *Or
     *  Balance exceeds $ _______ (if inputValue is empty)
     */
    if (dollarPattern.test(title)) {
        headerTitle = title.split('%s');
        // Fix for "AVAILABLE_CREDIT" : inputValue
        if (!inputValue) {
            var tempTitle = headerTitle[0].trim();
            tempTitle += '_____';
            headerTitle.splice(0, 1, tempTitle);
        }
        else {
            // Check that the input value string will be formatted correctly i.e. 1,000.00 instead of 1000
            var tmpValue = inputValue === null || inputValue === void 0 ? void 0 : inputValue.replace(',', ''); // Removing any , (commas)
            var formattedInput = Number(tmpValue).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
            headerTitle.splice(1, 0, _jsx(Title, __assign({ as: "span", bold: true }, { children: formattedInput })));
        }
    }
    /*
     *Splitting the title by %d into an array and replacing values as follows:
     *  Payment is due in %d days
     *To
     *  Payment is due in 15 days (if inputValue is not empty)
     *Or
     *  Payment is due in ___ days (if inputValue is empty)
     */
    if (datePattern.test(title)) {
        headerTitle = title.split('%d');
        if (inputValue === '') {
            headerTitle.splice(1, 0, '_____');
        }
        else {
            if (inputValue === '1') {
                headerTitle[1] = "".concat(i18next.t('helperText.day'));
            }
            headerTitle.splice(1, 0, _jsx(Title, __assign({ as: "span", bold: true }, { children: inputValue })));
        }
    }
    return headerTitle;
};
